import React, { useRef, useEffect, useCallback, useState } from 'react';
import { fetch, fetchByJSON, GetDataFrameInfo, useCachedData, useSimpleForm,toUnicode } from '../../util/util'
import './index.css'
import { push } from 'connected-react-router'
import { useSelector, useDispatch } from 'react-redux'
import { actions as DataSetActions } from '../../reducer/dataset'
import { Checkbox, Modal } from '../../util/ui'
import { DropDown, MultiSelect, Button, Label } from '../../util/ui_components'
import authHeader from '../../services/auth-header';
import sanitizeJsonString from '../common/sanitize';
import { thebeConfigR } from '../../util/thebeConfigs';
import { usePageKernel, attachCells } from '../../util/thebeSession';
import Table from '../common/table'
// import Tip from '../common/tip'
import { InlineTip } from '../common/tip'
import { keyBy } from 'lodash';

// const reconnectErrorFunction = () => {
//   alert('Kernel is taking too much time. Please reduce the data size!')
// }

const reconnectErrorFunction = () => {
  const overlay = document.createElement('div');
  overlay.style.cssText = `
    position: fixed;
    inset: 0;
    background: transparent;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const spinner = document.createElement('div');
  spinner.style.cssText = `
    width: 48px;
    height: 48px;
    border: 5px solid rgba(63, 91, 203, 0.84);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  `;

  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin { to { transform: rotate(360deg); } }
  `;

  document.head.appendChild(style);
  overlay.appendChild(spinner);
  document.body.appendChild(overlay);

  setTimeout(() => {
    overlay.remove();
    style.remove();
  }, 1000);
};


const Options = {
    'ConvertCases': 'Convert Cases',
    'ConvertCategoricalToNumerical': 'Convert Categorical to Numerical',
    'ConvertNumericalToCategorical': 'Convert Numerical to Categorical',
    'CreateFeaturesByArithmeticOperations': 'Create Features by Arithmetic Operations',
    'StandardScaler': 'Standard Scaler',
    'MinmaxScaler': 'Minmax Scaler',
    'TextDataFeatureCheckBasicFeatures': 'Text Data: Check Basic Features',
    'TextDataFeatureLabelValuesInColumns': 'Text Data: Label Values in Columns',
    'TextDataFeatureFeatureEngineering': 'Text Data: Feature Engineering',
    'AddColumn': 'Add Column',
    'UpdateCellIndividual': 'Update Cell Individual',
    'UpdateCellBatch': 'Update Cell Batch',
    'SortData': 'Sort Data',
    'ConvertSequences': 'Convert Sequences'
}

const getCanOperation = (dataset, operation) => {
    switch (operation) {
        case Options.ConvertCases:
            return [!!dataset.cate_cols.length, 'No category column to convert']
        case Options.ConvertCategoricalToNumerical:
            return [!!dataset.cate_cols.length, 'No category column to convert']
        case Options.ConvertNumericalToCategorical:
            return [!!dataset.num_cols.length, 'No numerical column to convert']
        case Options.CreateFeaturesByArithmeticOperations:
            return [!!dataset.num_cols.length, 'No numerical column to convert']
        case Options.StandardScaler:
            return [!!dataset.num_cols.length, 'No numerical column to convert']
        case Options.MinmaxScaler:
            return [!!dataset.num_cols.length, 'No numerical column to convert']
        case Options.TextDataFeatureCheckBasicFeatures:
            return [!!dataset.cate_cols.length, 'No category column to convert']
        case Options.TextDataFeatureLabelValuesInColumns:
            return [!!dataset.cate_cols.length, 'No category column to convert']
        case Options.TextDataFeatureFeatureEngineering:
            return [!!dataset.cate_cols.length, 'No category column to convert']
        case Options.AddColumn:
            return [!!dataset.filename, 'No dataset loaded']
        case Options.UpdateCellIndividual:
            return [!!(dataset.cols && dataset.cols.length), 'No columns available']
        case Options.UpdateCellBatch:
            return [!!(dataset.cols && dataset.cols.length), 'No columns available']
        case Options.SortData:
            return [!!(dataset.cols && dataset.cols.length), 'No columns available for sorting']
        case Options.ConvertSequences:
            return [!!(dataset.cols && dataset.cols.length), 'No columns available for sorting']
    }
    return [false, '']
}


const getDisplayCode = {
    [Options.ConvertCases]: (subOption) => {
    console.log(subOption)
        return `
# Demo of "Convert Cases"
if (!requireNamespace("dplyr", quietly = TRUE)) {
    install.packages("dplyr")
}
library(dplyr)
columns <- list(${Object.keys(subOption).map(e => `"${e}"="${subOption[e]}"`).join(',')})

# Iterate over each column and perform the specified operation
for (column in names(columns)) {
    operation <- columns[[column]]
    
    if (operation == "to lowercase") {
        df[column] <- tolower(df[column])
    } else if (operation == "to uppercase") {
        df[column] <- toupper(df[column])
    }
}
print(df)
`},
    [Options.ConvertCategoricalToNumerical]: (subOption) => {
        // console.log(subOption)
        return `
# Demo of "Convert Categorical to Numerical "
if (!requireNamespace("dplyr", quietly = TRUE)) {
    install.packages("dplyr")
}
library(dplyr)
# column(s) will be affected
columns <- c(${Object.values(subOption).map(e => `"${e}"`).join(',')})

# Convert categorical columns to numerical
for (col in columns) {
  df[[col]] <- as.integer(as.factor(df[[col]]))
}
print(df)
print(head(df))
`},
    [Options.ConvertNumericalToCategorical]: (subOption) => {
        let column = []
        let bins = []
        let labels = []
        for(let key of Object.keys(subOption)){
            if(subOption[key]['checked']){
                column.push(key)
                bins.push(subOption[key]['bins'].replace("[","").replace("]","").split(','))
                labels.push(subOption[key]['label'].replace("[","").replace("]","").split(',').map(e => `"${e}"`))
            }
        }
        return `
# Demo of "Convert Numerical to Categorical"
if (!requireNamespace("dplyr", quietly = TRUE)) {
    install.packages("dplyr")
}
library(dplyr)

# change to the column to be tested from dataset
columns <- c(${column.map(e => `"${e}"`).join(',')})

# Define the bins and labels
bins <- list(${bins.map(e=>`c(${e})`).join(',')} )
labels <- list(${labels.map(e=>`c(${e})`).join(',')})

# Convert numerical columns to categorical using bins and labels
for (i in 1:length(columns)) {
  column <- columns[i]
  bin <- bins[[i]]
  label <- labels[[i]]
  # Ensure the column is numeric
  if (!is.numeric(df[[column]])) {
    df[[column]] <- as.numeric(df[[column]])
  }
  df[[column]] <- cut(df[[column]], breaks = bin, labels = label, right = FALSE)
}
# Print the first few rows of the data frame
print(head(df)) 
`},
    [Options.CreateFeaturesByArithmeticOperations]: (subOption) => {
        let values = Object.values(subOption)
        return `
# Demo of "Create Features By Arithmetic Operations"
col1_arithmetic <- '${values[0]}'
operation <- '${values[1]}'
col2_arithmetic <- '${values[2]}'
new_colname <- '${values[3]}'

# Perform the arithmetic operation and create the new column
if (operation == '+') {
  df[[new_colname]] <- df[[col1_arithmetic]] + df[[col2_arithmetic]]
} else if (operation == '-') {
  df[[new_colname]] <- df[[col1_arithmetic]] - df[[col2_arithmetic]]
} else if (operation == '*') {
  df[[new_colname]] <- df[[col1_arithmetic]] * df[[col2_arithmetic]]
} else if (operation == '/') {
  df[[new_colname]] <- df[[col1_arithmetic]] / df[[col2_arithmetic]]
}
# Print the entire data frame
print(df)

`},
    [Options.StandardScaler]: (subOption) => {
        let values = Object.values(subOption)
        return `
# Demo of "Standard Scaler"
if (!requireNamespace("dplyr", quietly = TRUE)) {
    install.packages("dplyr")
}
library(dplyr)

cols <- c(${values.map(e => `'${e}'`).join(",")})
stand_scaler_col<- c()
for (col in cols) {
    stand_scaler_col <- c(stand_scaler_col, col)
}
print(paste('stand_scaler_col= ', toString(stand_scaler_col)))

# Standard scaling the columns
df[stand_scaler_col] <- scale(df[stand_scaler_col])
# Print the first few rows of the data frame
print(head(df))

`},
    [Options.MinmaxScaler]: (subOption) => {
        let values = Object.values(subOption)
        return `
# Demo of "Minmax Scaler"

# Load necessary library
library(scales)

cols <- c(${values.map(e => `'${e}'`).join(",")})
stand_scaler_col<- c()
for (col in cols) {
    stand_scaler_col <- c(stand_scaler_col, col)
}
print(paste('stand_scaler_col= ', toString(stand_scaler_col)))

# MinMax scaling function
min_max_scaler <- function(x) {
    (x - min(x)) / (max(x) - min(x))
}

# Apply MinMax scaling to the specified columns
for (col in stand_scaler_col) {
    df[[col]] <- min_max_scaler(df[[col]])
}
# Print the first few rows of the data frame
print(head(df))

`},
    [Options.TextDataFeatureCheckBasicFeatures]: (subOption) => {
        let values = Object.values(subOption).map(e => `'${e}'`)
        return `
# Demo of "Text Data: Check Basic Features"
# Load necessary libraries

if (!requireNamespace("tm", quietly = TRUE)) {
    install.packages("tm")
}

if (!requireNamespace("wordcloud", quietly = TRUE)) {
    install.packages("wordcloud")
}
if (!requireNamespace("dplyr", quietly = TRUE)) {
    install.packages("dplyr")
}

library(dplyr)
library(tm)
library(wordcloud)

basic_col <- ${values[0]}
basic_operation <- ${values[1]}

if (basic_operation == 'check most common words') {
  all_words <- unlist(strsplit(df[[basic_col]], "\\s+"))
  freq_table <- table(all_words)
  freq_table <- sort(freq_table, decreasing = TRUE)
  barplot(freq_table[1:100], las = 2, col = "blue", main = "Most Common Words")
} else if (basic_operation == 'visualize: wordcloud') {
  text <- paste(df[[basic_col]], collapse = " ")
  wordcloud(text, max.words = 2000, colors = brewer.pal(8, "Dark2"))
} else if (basic_operation == 'words count') {
  new_basic_col <- paste0(basic_col, '_words_count')
  df[[new_basic_col]] <- sapply(strsplit(df[[basic_col]], "\\s+"), length)
} else if (basic_operation == 'charactures count') {
  new_basic_col <- paste0(basic_col, '_charactures_count')
  df[[new_basic_col]] <- nchar(df[[basic_col]])
} else if (basic_operation == 'average word length') {
  avg_word_length <- function(sentence) {
    words <- strsplit(sentence, "\\s+")[[1]]
    if (length(words) == 0) return(0)
    sum(nchar(words)) / length(words)
  }
  new_basic_col <- paste0(basic_col, '_average_word_length')
  df[[new_basic_col]] <- sapply(df[[basic_col]], avg_word_length)
} else if (basic_operation == 'stopwords count') {
  stopwords <- stopwords("en")
  stopword_count <- function(sentence) {
    words <- strsplit(sentence, "\\s+")[[1]]
    sum(words %in% stopwords)
  }
  new_basic_col <- paste0(basic_col, '_stopwords_count')
  df[[new_basic_col]] <- sapply(df[[basic_col]], stopword_count)
} else if (basic_operation == 'numbers count') {
  numbers_count <- function(sentence) {
    words <- strsplit(sentence, "\\s+")[[1]]
    sum(sapply(words, is.numeric))
  }
  new_basic_col <- paste0(basic_col, '_numbers_count')
  df[[new_basic_col]] <- sapply(df[[basic_col]], numbers_count)
} else if (basic_operation == 'uppercase count') {
  uppercase_count <- function(sentence) {
    words <- strsplit(sentence, "\\s+")[[1]]
    sum(words == toupper(words) & grepl("[A-Z]", words))
  }
  new_basic_col <- paste0(basic_col, '_uppercase_count')
  df[[new_basic_col]] <- sapply(df[[basic_col]], uppercase_count)
}

# Print the resulting data frame
print(head(df))
`},
[Options.TextDataFeatureLabelValuesInColumns]: (subOption) => {
        let columns = Object.keys(subOption)
        let currVal = []
        let colname = []
        let newVal = []
        for(let key of columns){
            currVal.push(subOption[key]['Currval'].replace("[","").replace("]","").split(',').map(e => `"${e}"`))
            colname.push(subOption[key]['NewCol'].replace("[","").replace("]","").split(',').map(e => `"${e}"`))
            newVal.push(subOption[key]['NewVal'].replace("[","").replace("]","").split(',').map(e => `"${e}"`))
        }
    return `
# Demo of "Text Data Feature Label Values in Columns"
columns <- c(${columns.map(e => `"${e}"`).join(",")})
col_currVal <- list(${currVal.map(e=>`c(${e})`).join(',')})
new_colnames <- list(${colname.map(e=>`c(${e})`).join(',')})
col_newVal <- list(${newVal.map(e=>`c(${e})`).join(',')})

# Apply the feature label mapping to create new columns
for (i in 1:length(columns)) {
  col <- columns[i]
  currVal <- col_currVal[[i]]
  newColnames <- new_colnames[[i]]
  newVal <- col_newVal[[i]]
  
  new_feat_assigns <- setNames(newVal, currVal)
  
  for (newColname in newColnames) {
    df[[newColname]] <- sapply(df[[col]], function(x) new_feat_assigns[x])
  }
}

# Print the resulting data frame
print(df)
`},
[Options.TextDataFeatureFeatureEngineering]: (subOption) => {
    let col = subOption['text_feateng_col']
    let operation = subOption['text_feateng_operation']
    return `
# Demo of "Text Data: Feature Engineering"

if (!requireNamespace("tm", quietly = TRUE)) {
install.packages("tm")
}

if (!requireNamespace("SnowballC", quietly = TRUE)) {
install.packages("SnowballC")
}
if (!requireNamespace("textstem", quietly = TRUE)) {
install.packages("textstem")
}
if (!requireNamespace("dplyr", quietly = TRUE)) {
    install.packages("dplyr")
}

library(dplyr)
library(tm)
library(SnowballC)
library(textstem)

text_feateng_col <- '${col}'
text_feateng_option <- c(${operation.map(e => `'${e}'`)})

# Perform text feature engineering based on the options

if ('convert to lower case' %in% text_feateng_option) {
  df[[text_feateng_col]] <- tolower(df[[text_feateng_col]])
}
if ('remove punctuation' %in% text_feateng_option) {
  df[[text_feateng_col]] <- gsub("[[:punct:]]", "", df[[text_feateng_col]])
}
if ('remove stopwords automatically' %in% text_feateng_option) {
  stop_words <- stopwords("en")
  df[[text_feateng_col]] <- sapply(df[[text_feateng_col]], function(x) {
    paste(setdiff(unlist(strsplit(x, "\\s+")), stop_words), collapse = " ")
  })
}
if ('remove digits' %in% text_feateng_option) {
  df[[text_feateng_col]] <- gsub("\\d+", "", df[[text_feateng_col]])
}
if ('Word Normalization1: lemmatization' %in% text_feateng_option) {
  df[[text_feateng_col]] <- sapply(df[[text_feateng_col]], function(x) {
    paste(lemmatize_words(unlist(strsplit(x, "\\s+"))), collapse = " ")
  })
}
if ('Word Normalization2: stemming' %in% text_feateng_option) {
  df[[text_feateng_col]] <- sapply(df[[text_feateng_col]], function(x) {
    paste(wordStem(unlist(strsplit(x, "\\s+")), language = "en"), collapse = " ")
  })
}
if ('Extract Model1: CountVectorizer' %in% text_feateng_option) {
  dtm <- DocumentTermMatrix(Corpus(VectorSource(df[[text_feateng_col]])))
  tf <- as.matrix(dtm)
  tf_feat_names <- colnames(tf)
}
if ('Extract Model2: TfidfVectorizer' %in% text_feateng_option) {
  dtm <- DocumentTermMatrix(Corpus(VectorSource(df[[text_feateng_col]])), control = list(weighting = weightTfIdf))
  tfidf <- as.matrix(dtm)
  tfidf_feat_names <- colnames(tfidf)
}

# Print the resulting data frame
print(head(df))
`},
[Options.AddColumn]: (subOption) => {
    return `
# Demo of "Add Column"
new_column <- '${subOption.newColumn}'
default_value <- ${JSON.stringify(subOption.defaultValue)}
# Optionally, if you want to assign this value for every row,
# you can use: rep(default_value, nrow(df))
df[[new_column]] <- default_value
print(head(df))
`
},
[Options.UpdateCellIndividual]: (subOption) => {
    return `
# Demo of "Update Cell" (Individual Mode)

target_column <- '${subOption.column}'
target_data_type <- '${subOption.type}'
new_value_raw <- ${JSON.stringify(subOption.value)}

# Convert new_value based on the target data type
if (target_data_type == 'int') {
new_value <- as.integer(new_value_raw)
} else if (target_data_type == 'float') {
new_value <- as.numeric(new_value_raw)
} else if (target_data_type == 'bool') {
new_value <- tolower(new_value_raw) == 'true'
} else if (target_data_type == 'string') {
new_value <- as.character(new_value_raw)
} else {
new_value <- new_value_raw
}

# Get condition parameters and normalize the condition value
condition_column <- '${subOption.condition_column}'
condition_value <- ${JSON.stringify(subOption.condition_value)}
condition_value_str <- tolower(trimws(as.character(condition_value)))

# Find the indices in df where the condition holds
indices <- which(tolower(trimws(as.character(df[[condition_column]]))) == condition_value_str)

# Update the target column for each matching row
for(i in indices) {
df[i, target_column] <- new_value
}

print(df)
  `
},
[Options.UpdateCellBatch]: (subOption) => {
    return `
# Demo of "Update Cell Batch"
column <- '${subOption.column}'
# Split the input string by comma and trim whitespace from each value
new_values <- trimws(unlist(strsplit(${JSON.stringify(subOption.value)}, ",")))
n <- length(new_values)
start_row <- 1  # R indexing starts at 1
# Update consecutive rows starting at the provided row index
for(i in 1:n) {
df[start_row + i - 1, column] <- new_values[i]
}
print(df)
  `
  }
  ,
  [Options.SortData]: (subOption) => {
    return `
# Demo of "Sort Data"
suppressPackageStartupMessages(suppressWarnings(library(dplyr)))
suppressPackageStartupMessages(suppressWarnings(library(rlang)))

# Convert the incoming sortColumns array into an R vector
sort_columns <- c(${ subOption.sortColumns && subOption.sortColumns.length 
    ? subOption.sortColumns.map(col => '"' + col + '"').join(", ")
    : "" })
sort_order <- tolower('${subOption.sortOrder}')

if (length(sort_columns) > 0) {
if (sort_order == 'ascending') {
    ndf <- arrange(df, !!!syms(sort_columns))
} else if (sort_order == 'descending') {
    ndf <- arrange(df, desc(!!!syms(sort_columns)))
}
}
print(head(ndf))
  `
  },
  [Options.ConvertSequences]: (subOption) => {
    return `
# Demo of "Sequence Operations"
if (!requireNamespace("Biostrings", quietly = TRUE)) {
  if (!requireNamespace("BiocManager", quietly = TRUE)) {
    install.packages("BiocManager", quiet = TRUE, repos = "https://cran.r-project.org")
  }
  BiocManager::install("Biostrings", ask = FALSE, update = FALSE, quiet = TRUE)
}
suppressPackageStartupMessages(library(Biostrings))

operation <- "${subOption.operation}"
column    <- "${subOption.column}"

# ensure column is character
seqs <- as.character(df[[column]])

if (operation == "Reverse Complement") {
dna <- DNAStringSet(seqs)
df[[column]] <- as.character(reverseComplement(dna))
} else if (operation == "Reverse") {
dna <- DNAStringSet(seqs)
df[[column]] <- as.character(reverse(dna))
} else if (operation == "Complement") {
dna <- DNAStringSet(seqs)
df[[column]] <- as.character(complement(dna))
} else if (operation == "Convert to RNA") {
df[[column]] <- chartr("T", "U", seqs)
} else if (operation == "Convert to DNA") {
df[[column]] <- chartr("U", "T", seqs)
} else if (operation == "Translate") {
dna <- DNAStringSet(seqs)
aa  <- translate(dna)
df[[column]] <- as.character(aa)
} else if (operation == "Match Pattern") {

pattern <- "${subOption.pattern}"
dna     <- DNAStringSet(seqs)

hits <- vmatchPattern(pattern, dna)

df$pattern_matches <- sapply(hits, function(vs) {
if (length(vs) > 0) paste(as.character(vs), collapse = ",") else NA
})
}

print(df)
    `
  }
}

const getInitialCode = (data) => `
library(jsonlite)
data_json <- '${data}'
# Convert JSON to a list. pandas' df.to_json() omits the row-index key entirely for any
# NaN cell (rather than including it as null), so columns with missing values end up with
# fewer entries than columns with none -- reindex every column against the union of all
# row indices first, so missing cells become proper NA in the right position, before
# combining into a data frame.
df_list <- fromJSON(data_json)
all_indices <- unique(unlist(lapply(df_list, names)))
all_indices <- all_indices[order(as.numeric(all_indices))]
columns_list <- lapply(df_list, function(col) {
    col_names <- names(col)
    sapply(all_indices, function(idx) {
        if (idx %in% col_names) {
            val <- col[[idx]]
            if (is.null(val)) NA else val
        } else {
            NA
        }
    })
})
names(columns_list) <- names(df_list)

# Combine the list into a proper data frame
df <- as.data.frame(columns_list, stringsAsFactors = FALSE, check.names = FALSE)
df <- type.convert(df, as.is = TRUE)
`

const supportCode = `
library(readr) # For reading CSV files
library(dplyr) # For data manipulation
library(ggplot2) # For data visualization

# Manually load other libraries if necessary

# Replace '<filename.csv>' with the dataset you need
df <- read_csv('<filename.csv>')s
`

const FeatureEngineeringR = () => {
    useCachedData()
    let [option, setOption] = useState('')
    let subOption = useRef({})
    const [_, forceUpdate] = useState(0);
    let [errorMsg, setErrorMsg] = useState('')
    let [showOptionModal, setShowOptionModal] = useState(false)
    const [modalKey, setModalKey] = useState(0);
    let dataset = useSelector(state => state.dataset)
    let dispatch = useDispatch()
    let kernelRef = useRef()
    // one kernel per mounted page, shut down again on unmount
    const getPageKernel = usePageKernel(thebeConfigR)
    let codeParent = useRef()
    const [code, setCode] = useState('')
    const dfJSON = useRef()
    const [activateStatus, setActivateStatus] = useState('Loading...')
    const [highlightConfig, setHighlightConfig] = useState({})
    let [previousCondition, setPreviousCondition] = useState({})
    let [currentCondition, setCurrentCondition] = useState({})

    useEffect(() => {
        reconnectErrorFunction();
        if (!code) return

        codeParent.current.innerHTML = ''
        let pre = document.createElement('pre')
        pre.setAttribute('data-executable', 'true')
        pre.setAttribute('data-language', 'R')
        codeParent.current.appendChild(pre)
        pre.innerHTML = code
        let isActive = true

        // Only the freshly created <pre> needs rendering here -- bootstrap() would also
        // request another kernel, and thebe's "status" bus is global, so the handler this
        // used to register kept firing (for every page's kernel) after unmount.
        getPageKernel().then((kernel) => {
            if (!isActive) return
            kernelRef.current = kernel
            kernelRef.current._reconnect = reconnectErrorFunction;
            attachCells(kernel)
        }).catch((err) => console.error('Error connecting to the R kernel:', err))

        return () => { isActive = false }
    }, [code])

    useEffect(() => {
      console.log('XXX',dfJSON.current)
        if (!dataset.filename) {
            setActivateStatus('No data')
            return
        }

        let isActive = true

        getPageKernel().then((kernel) => {
            if (!isActive) return
            kernelRef.current = kernel
            kernelRef.current._reconnect = reconnectErrorFunction;
            setActivateStatus('Ready')
        }).catch((err) => {
            if (!isActive) return
            console.error('Error connecting to the R kernel:', err)
            setActivateStatus('Error connecting to R')
        })

        return () => { isActive = false }
    }, [dataset.filename])

    const runCode = async (e) => {
        try {
            setActivateStatus('Running Initial code ...');
        let res = await fetchByJSON('current_data_json', {
            filename: dataset.filename
        });
    
        let json = await res.json();
        let json_string = sanitizeJsonString(json.data);
    
        const fullCode = getInitialCode(json_string) + '\n' + code;
    
        let res2 = await kernelRef.current.requestExecute({ code: fullCode }).done;
    
        document.querySelector('.thebelab-run-button').click();
        setActivateStatus('Ready');
        } catch (err) {
            console.error("Error during run:", err);
            setActivateStatus('Error during run');
        }
    }
    

    const onDownload = () => {
        const element = document.createElement('a')
        const file = new Blob([supportCode, code], {type: "text/plain"})
        element.href = URL.createObjectURL(file)
        element.download = "download_test.py" // or .txt
        document.body.appendChild(element)
        element.click()
    }

    // const assignSubOption = useCallback((prop, entry) => {
    //     subOption.current[prop] ||= {};
    //     Object.assign(subOption.current[prop], entry)
    // }, [subOption])

    const assignSubOption = useCallback((col, entry) => {
        subOption.current = {
            ...subOption.current,
            [col]: {
                ...(subOption.current[col] || {}),
                ...entry
            }
        };
        forceUpdate(prev => prev + 1);
    }, []);

    let ts = new Date().getTime()
    console.log("subOption: ", subOption);
    return (<div className='flex flex-col min-h-screen bg-gray-100'>
        <Modal key={modalKey} isOpen={showOptionModal} onClose={() => {
        }} setIsOpen={setShowOptionModal} contentStyleText="mx-auto">
            <div className='p-2 flex flex-col' style={{maxWidth:'80vw'}}>
                {option === Options.ConvertCases ?
                    <div className="flex flex-col gap-2">
                        {dataset.cate_cols.map((name,i) =>
                            <div className='flex flex-row w-full items-center' key={name + ts}>
                                <div className='px-10 py-2 w-1/3 label-left'>{name + ':'}</div>
                                <DropDown zIndex={100-i} onSelect={e => {
                                    subOption.current[name] = e
                                }} defaultText={`Select convert type`} showOnHover={false} width="w-60 mr-0" defaultValue='' blankOption='no change' items={['to lowercase', 'to uppercase']} />
                            </div>
                        )}
                    </div> : ''}

                {option === Options.ConvertCategoricalToNumerical ? <div>
                    <MultiSelect defaultText={`Select columns to convert`} defaultOpen={false} selections={dataset.cate_cols} width="w-72" onSelect={e => subOption.current = e} />
                </div> : ''}

                {option === Options.ConvertNumericalToCategorical ?
                    <div className='grid grid-cols-3 gap-2 grid-num-cat'>
                        {dataset.num_cols.map((col, i) => <React.Fragment key={i}>
                            {/* <Checkbox label={col} onChange={(e, checked) => assignSubOption(col, { checked })} name='suboption_checked' item={col} /> */}
                            <Checkbox label={col} checked={!!subOption.current[col]?.checked} onChange={(e, checked) => assignSubOption(col, { checked })} name='suboption_checked' item={col} />
                            <input className='Bins mx-3 px-1 focus:outline-none rounded-full' placeholder='Bins: int or float list' onChange={e => assignSubOption(col, { bins: e.target.value })} />
                            <input className='mx-3 px-1 focus:outline-none rounded-full' placeholder='Labels: string list' onChange={e => assignSubOption(col, { label: e.target.value })} />
                        </React.Fragment>)}
                        <Label customStyleText={`w-100 mr-0`} text="eg. column 'Age', Bins=[0,2,17,65,99], Labels=[Toddler,Child,Adult,Elderly]" />
                        <Label customStyleText={`w-100 mr-0`} text="eg. column 'Survived', Bins=[0,1,2], Labels=[No,Yes] *Here 0~1 stands for No and 1~2 stands for Yes." />
                        <Label customStyleText={`w-100 mr-0`} text="*hint: Bins should always be greater by one than Labels in order to create lower bound and upper bound for the data." />
                    </div> : ''}

                {option === Options.CreateFeaturesByArithmeticOperations ?
                    <div className="flex gap-2">
                        <DropDown defaultText={'Select column 1'} showOnHover={false} width={`w-64`} items={dataset.num_cols}
                            onSelect={e => {
                                subOption.current.col1_arithmetic = e
                            }} ></DropDown>
                        <DropDown defaultText={'Select operation'} showOnHover={false} width={`w-64`} items={['+', '-', '*', '/']}
                            onSelect={e => {
                                subOption.current.operation = e
                            }} ></DropDown>
                        <DropDown defaultText={'Select column 2'} showOnHover={false} width={`w-64`} items={dataset.num_cols}
                            onSelect={e => {
                                subOption.current.col2_arithmetic = e
                            }} ></DropDown>
                        <input className='Bins m-3 px-5 py-2 focus:outline-none rounded-full' placeholder='New Column Name' name='new_colname' onChange={e => subOption.current.new_colname = e.target.value} />
                    </div> : ''}

                {option === Options.StandardScaler ? <div>
                    <MultiSelect width="w-72 mr-0" defaultText={`Select columns to convert`} selections={dataset.num_cols} onSelect={e => subOption.current = e} />
                </div> : ''}


                {option === Options.MinmaxScaler ? <div>
                    <MultiSelect width="w-72 mr-0" defaultText={`Select columns to convert`} selections={dataset.num_cols} onSelect={e => subOption.current = e} />
                </div> : ''}

                {option === Options.TextDataFeatureCheckBasicFeatures ?
                    <div className="flex gap-2">
                        <DropDown defaultText={'Select column'} showOnHover={false} width={`w-64`} items={dataset.cate_cols}
                            onSelect={e => {
                                subOption.current.check_basic_col = e
                            }} />
                        <DropDown defaultText={'Select operation'} showOnHover={false} width={`w-64`} items={['check most common words', 'visualize: wordcloud', 'words count', 'charactures count', 'average word length', 'stopwords count', 'numbers count', 'uppercase count']}
                            onSelect={e => {
                                subOption.current.basic_operation = e
                            }} />

                    </div> : ''}

                {option === Options.TextDataFeatureLabelValuesInColumns ?
                    <div className='grid grid-cols-4'>
                        {dataset.cate_cols.map((col, i) => <React.Fragment key={i}>
                            <Checkbox label={col} name='suboption_checked_text' item={col} onChange={(e, checked) => assignSubOption(col, { checked })} />
                            <input className='Bins m-2 px-2 focus:outline-none rounded-full' placeholder='Current Values: string list' name={col + '_CurrVal'} onChange={e => assignSubOption(col, { Currval : e.target.value })} />
                            <input className='Bins m-2 px-2 focus:outline-none rounded-full' placeholder='New Column Name: string' name={col + '_NewCol'} onChange={e => assignSubOption(col, { NewCol : e.target.value })} />
                            <input className='m-2 px-2 focus:outline-none rounded-full' placeholder='New Values: string list' name={col + '_NewVal'} onChange={e => assignSubOption(col, { NewVal : e.target.value })} />
                        </React.Fragment>)}
                        <Label text=''></Label>
                        <Label customStyleText={`w-100 mr-0`} text="eg. current column 'publication', Current Values = [ Atlantic, National Review, Breitbart, New York Times],  New Column Name='politic lean', New Values=[ left, right, right, left]" />
                    </div> : ''}

                {option === Options.TextDataFeatureFeatureEngineering ?
                    <div className="flex flex-col gap-2">
                        <DropDown zIndex={100} width="w-30" defaultText={'Select column'} showOnHover={false} items={dataset.cate_cols}
                            onSelect={e => {
                                subOption.current.text_feateng_col = e
                            }} />
                        <MultiSelect zIndex={99} width="w-fill" defaultText={'Select one/multi-operation'} defaultOpen={false} selections={['convert to lower case', 'expand contraction', 'remove punctuation', 'remove stopwords automatically', 'remove digits', 'Word Normalization1: lemmatization', 'Word Normalization2: stemming', 'Extract Model1: CountVectorizer', 'Extract Model2: TfidfVectorizer']}
                            onSelect={e => subOption.current.text_feateng_operation = e} />
                    </div> : ''}

                    {option === Options.AddColumn ? (
                        <div className="flex flex-col gap-2">
                            <input 
                                className="Bins m-2 px-2 focus:outline-none rounded-full" 
                                placeholder="New Column Name" 
                                onChange={e => subOption.current.newColumn = e.target.value} 
                            />
                            <input 
                                className="Bins m-2 px-2 focus:outline-none rounded-full" 
                                placeholder="Default Value" 
                                onChange={e => subOption.current.defaultValue = e.target.value} 
                            />
                        </div>
                    ) : ''}
                {option === Options.UpdateCellIndividual ? (
                <div className="grid gap-4">
                    {/* Header Row */}
                    <div className="grid grid-cols-5 gap-4">
                    <label className="text-sm font-semibold">Target Column</label>
                    <label className="text-sm font-semibold">New Value</label>
                    <label className="text-sm font-semibold">Data Type</label>
                    <label className="text-sm font-semibold">Condition Column</label>
                    <label className="text-sm font-semibold">Condition Value</label>
                    </div>
                    {/* Input Row */}
                    <div className="grid grid-cols-5 gap-4">
                    <DropDown
                        defaultText="Select target column"
                        showOnHover={false}
                        width="w-full"
                        items={dataset.cols}
                        onSelect={(val) => (subOption.current.column = val)}
                    />
                    <input
                        className="px-2 py-1 focus:outline-none rounded border w-full"
                        placeholder="Enter new value"
                        onChange={(e) => (subOption.current.value = e.target.value)}
                    />
                    <DropDown
                        defaultText="Select data type"
                        showOnHover={false}
                        width="w-full"
                        items={['string', 'int', 'float', 'bool']}
                        onSelect={(val) => (subOption.current.type = val)}
                    />
                    <DropDown
                        defaultText="Select condition column"
                        showOnHover={false}
                        width="w-full"
                        items={dataset.cols}
                        onSelect={(val) => (subOption.current.condition_column = val)}
                    />
                    <input
                        className="px-2 py-1 focus:outline-none rounded border w-full"
                        placeholder="Enter condition value"
                        onChange={(e) =>
                        (subOption.current.condition_value = e.target.value)
                        }
                    />
                    </div>
                </div>
                ) : null}
                    {option === Options.UpdateCellBatch ? (
                    <div className="grid gap-4">
                        <div className="grid grid-cols-3 gap-4">
                        <label className="text-sm font-semibold">Column</label>
                        <label className="text-sm font-semibold">
                            New Values (comma separated)
                        </label>
                        <label className="text-sm font-semibold">Data Type</label>
                        </div>
                        <div className="grid grid-cols-3 gap-4">
                        <DropDown
                            defaultText="Select column"
                            showOnHover={false}
                            width="w-full"
                            items={dataset.cols}
                            onSelect={(val) => (subOption.current.column = val)}
                        />
                        <input
                            className="px-2 py-1 focus:outline-none rounded border w-full"
                            placeholder="e.g. 3.5"
                            onChange={(e) => (subOption.current.value = e.target.value)}
                        />
                        <DropDown
                            defaultText="Select data type"
                            showOnHover={false}
                            width="w-full"
                            items={['string', 'int', 'float', 'bool']}
                            onSelect={(val) => (subOption.current.type = val)}
                        />
                        </div>
                    </div>
                    ) : null}
                    {option === Options.SortData ? (
                        <div className='flex flex-row'>
                            <MultiSelect 
                                defaultText="Select columns to sort"
                                defaultOpen={false}
                                selections={dataset.cols}
                                width="w-72"
                                onSelect={e => subOption.current.sortColumns = e} 
                            />
                            <DropDown defaultText="Select sort order" showOnHover={false} width="w-64" items={['Ascending', 'Descending']}
                                onSelect={e => {
                                    subOption.current.sortOrder = e;
                                }} />
                        </div>
                    ) : ''}
                    {option === Options.ConvertSequences && (
                    <div className="grid grid-cols-3 gap-2">
                        <DropDown
                        defaultText="Sequence Operation"
                        showOnHover={false}
                        width="w-64"
                        items={[
                            'Reverse',
                            'Reverse Complement',
                            'Complement',
                            'Convert to RNA',
                            'Convert to DNA',
                            'Translate',
                            'Match Pattern'
                        ]}
                        onSelect={e => (subOption.current.operation = e)}
                        />

                        <DropDown
                        defaultText="Select column"
                        showOnHover={false}
                        width="w-full"
                        items={dataset.cols}
                        onSelect={val => (subOption.current.column = val)}
                        />

                        <input
                        type="text"
                        placeholder="Pattern(empty if not Match Pattern)"
                        className="px-2 border rounded"
                        onChange={e => (subOption.current.pattern = e.target.value)}
                        />
                    </div>
                    )}

                <div className="flex justify-end mt-10">
                    <Button text='Confirm' width='w-24' customStyle={{padding:'auto'}} onClick={async () => {
                        if (JSON.stringify(previousCondition)==="{}") {
                            let prevres = await fetchByJSON('current_data_json', {filename: dataset.filename})
                            let prevjson = await prevres.json()
                            setPreviousCondition(JSON.parse(prevjson.data))
                        } else {
                            setPreviousCondition(currentCondition)
                        }

                        setShowOptionModal(false)
                        // let currentParam = {
                        //     subOption: {...subOption.current},
                        //     activeOption: option,
                        //     filename: dataset.filename
                        // }
                        // dispatch(DataSetActions.setEngineering([...dataset.dataEngineering, currentParam]))
                        let res = await fetchByJSON('featureEngineering', { subOption:{...subOption.current},...{
                            activeOption:option,
                        }, filename: dataset.filename }) //send request
                        let json = await res.json()
                        setCode(getDisplayCode[option](subOption.current)) // demo code

                        $('#display_results').html(json.para_result)
                        document.getElementById("img").src = "data:image/png;charset=utf-8;base64," + json.plot_url
                        if (
                            subOption.current.operation === 'Match Pattern' &&
                            subOption.current.pattern
                            ) {
                            setHighlightConfig({
                                column:   subOption.current.column,
                                pattern:  subOption.current.pattern,
                                useRegex: false,
                            });
                            } else {
                            setHighlightConfig({});
                        }
                        dispatch(DataSetActions.setData({
                            cols: json.cols,
                            num_cols: json.num_cols,
                            cate_cols: json.cate_cols,
                            num_lists: json.num_lists,
                            cate_lists: json.cate_lists,
                            col_lists: json.col_lists,
                        }))
                        dispatch(DataSetActions.setTableData(JSON.parse(json.data)))
                        setCurrentCondition(JSON.parse(json.data))
                    }} />
                </div>
            </div>
        </Modal>
        <div className="flex flex-row h-20 w-full items-center justify-start bg-gray-100 shadow-md">
            <div className='mx-5 gap-2 w-8/12 flex justify-start'>
                <div className='w-72'>
                    {/* ['Convert Cases', 'Convert Categorical to Numerical', 'Convert Numerical to Categorical', 'Standard Scaler', 'Minmax Scaler', 'Text Data: Feature Extraction Models']; */}
                    {/* enabledOptionIndex={isTsv?[6]:[0,1,2,3,4,5]} */}
                    <DropDown width={'w-72'} height={'h-8'}
                        onSelect={option => {
                            {
                                setOption(option)
                                subOption.current = {}
                                setModalKey(prevKey => prevKey + 1);
                                setShowOptionModal(true)
                            }
                        }}
                        items={Object.values(Options)}
                        defaultText='Select option'
                        enabledOptionIndex={Object.keys(Options).map((key, i) => getCanOperation(dataset, key) ? i : -1).filter(i => i > -1)}
                    />
                </div>
                <div className='w-auto flex justify-center items-center px-1'>
                    <div className={``}>{activateStatus}</div>
                    <InlineTip zIndex={10} info='The loading status of a remote environment, R code will be executed in that environment as soon as it is ready.' />
                </div>

                <Button text={'Options'} width={'w-48'} onClick={() => {
                    if (option) {
                        setShowOptionModal(true)
                    }
                }} />
            </div>


            {/* demo code */}
            <Button onClick={() => {
                runCode()
            }} disabled={!code} width='w-32' text="Run" overrideClass={`ml-5  px-4 py-1 rounded font-semibold border focus:outline-none text-black cursor-pointer ${!code
                ? 'text-gray-400 cursor-default' : 'text-black cursor-pointer'}`} customStyle={{ backgroundColor: !!code ? '#4bd699' : 'inherit' }}  hoverAnimation={false} />
            <Button text="Undo" width={'w-24 ml-3'} onClick={async () => {
                // kernelRef.current.requestExecute({ code:getInitialCode(option,dfJSON.current) })
                dispatch(DataSetActions.setTableData(previousCondition))
                setCurrentCondition(previousCondition)
                // let res = await fetchByJSON('cleanEditedCache', {
                //     filename: dataset.filename
                // })
                // let json = await res.json()
                // if (json.success) {
                //     let previous = dataset.dataEngineering.slice(0, -1)
                //     dispatch(DataSetActions.setEngineering(previous))
                // }
            }}/>
            <Button text='Revert' width='w-24 mx-3' onClick={
                async (e) => {
                    setCode('')
                    if (dataset.filename) {
                        let res = await fetchByJSON('cleanEditedCache', {
                            filename: dataset.filename
                        })
            
                        let json = await res.json()
            
                        if (json.success) {
                            alert('Revert data success!')
                            dispatch(DataSetActions.emptyInfo())

                            // selectFileOption(dataset.filename, false)
                            // replace the above function with the first part of selectFileOption() in /home/index.jsx
                            let res2 = await fetch('/file/?filename=' + dataset.filename + '&default=' + (dataset.isDefault === true), {
                                method: 'GET',
                                headers: authHeader()
                            })
                            let json2 = await res2.json()
                          
                            if (json2.success) {
                                dispatch(DataSetActions.setData({
                                    filename: dataset.filename,
                                    info: GetDataFrameInfo(json2.info),
                                    data: JSON.parse(json2.data),
                                    cols: json2.cols,
                                    num_cols: json2.num_cols,
                                    col_lists: json2.col_lists,
                                    cate_cols: json2.cate_cols,
                                    cate_lists: json2.cate_lists,
                                    num_lists: json2.num_lists
                                }))
                            }
                            let json_string = sanitizeJsonString(json.data, false);
                            dispatch(DataSetActions.setTableData(JSON.parse(json_string)))
                        }
                        // setCurrentCondition({})
                    }
                }
            } />
            <Button text='Download' width='w-30 mx-3' onClick={onDownload} />

        </div>

        <div className="w-full flex flex-nowrap">
            <div className='w-1/2 text-gray-500 font-semibold'>
                <div className='scroll w-full flex justify-center items-center' style={{height:'100%'}}>

                    <Label text="Results:">
                        <div id="display_results" style={{ whiteSpace: 'pre-wrap' }} >Select an operation to see preprocessed results</div>
                    </Label>
                    <Label text="">
                        <img id="img" src="" />
                    </Label>
                </div>
            </div>
            {/* Demo code */}
            <div className='flex-grow-1 w-1/2' ref={codeParent}>
                {code ? code : <div className='w-full flex-grow-0 h-48 flex justify-center items-center text-gray-500 font-semibold'>
                    Select an operation to see the corresponding code
                </div>}
            </div>
        </div>



        <Table PageSize={10} highlightConfig={highlightConfig} />
    </div>)
}

export default FeatureEngineeringR